import { Result } from "@/functional/result";
import { CreateUserError, ErrorStateServiceForRoot } from "@/infrastructure/observables/errorState";
import { LoaderStateServiceForRoot } from "@/infrastructure/observables/loaderState";
import { RestClientHeader } from "../RestClientHeader";
import { serializeToJson } from "@/functional/datetimehelper";

export class AsyncRestClient {
  private static _withCookies = false;
  private static _noLoader = false;

  public static noLoader() {
    this._noLoader = true
  }


  public static Create(withCookies: boolean): Result<AsyncRestClient> {
    this._withCookies = withCookies
    this._noLoader = false
   

    return Result.ok<AsyncRestClient>(new AsyncRestClient());
  }

  private getHeader(withCookies: boolean) : Result<Map<string,string>> {
    const header: RestClientHeader = new RestClientHeader();
    return header.getHeader(withCookies);
  }


  public async exchangeForComponents<TRequest, TResponse>(
    endpoint: string,
    payload: TRequest): Promise<Result<TResponse>> {

    const errorState = ErrorStateServiceForRoot.getErrorStateService()
    errorState.resetErrorState();

    const loaderState = LoaderStateServiceForRoot.getLoaderStateService()
    if ( !AsyncRestClient._noLoader )
      loaderState.changeLoaderState({isInProgress: true})
    
    const result = await this.exchange<TRequest,TResponse>(endpoint,payload);

    if ( !AsyncRestClient._noLoader )
      loaderState.changeLoaderState({isInProgress: false})    
    
    if (result.isFailure) {
      errorState.changeErrorState(CreateUserError("Restclient.Request" , result.error))  
    }
    
    return result;
  }


  public async exchange<TRequest, TResponse>(
    endpoint: string,
    payload: TRequest
  ): Promise<Result<TResponse>> {
    try {

      const headerResult = this.getHeader(AsyncRestClient._withCookies);
      if (headerResult.isFailure) return Result.fail<TResponse>(headerResult.error);

      const response = await fetch(endpoint, {
        method: "POST",
        credentials: "include",
        mode: "cors",
        headers: Object.fromEntries(headerResult.getValue()),
        body: JSON.parse( serializeToJson(payload)),
      });

      if (!response.ok) {  
        
        let reason = "";
        try {
          for( const header of response.headers.entries() ) {
            if (header[0] === "Status-Reason-Development") {
              reason = header[1];
            }
          }
          return Result.fail<TResponse>(`"Error.Exchange => <br />Url: ${endpoint}<br /> Status: ${response.status.toString()}, Message: ${response.statusText ?? "htpp status"} Reason: ${reason} "`);        
        }
        catch(e) {
          console.error(e);
        }
      }

      try {
        for( const header of response.headers.entries() ) {
          if (header[0] === "Status-Reason-Development") {
            return Result.fail<TResponse>(`"Error.Exchange => <br />Url: ${endpoint}<br />, Message: ${header[1] ?? "reason uknknown"} "`);
          }
        }
      } catch (e) {
        console.error(e);
      }

      const result: TResponse = await response.json();
      return Result.ok<TResponse>(result);

    } catch (e) {
      return Result.fail<TResponse>(`"Error.Exchange => <br />Url: ${endpoint}<br />  Message: ${e} "`);
    }
  }

  public async apiPostGetPdf<Request> (endpoint: string, request: Request, pdfFileName: string): Promise<void>  {
    const headerResult = this.getHeader(AsyncRestClient._withCookies);
 
    const loaderState = LoaderStateServiceForRoot.getLoaderStateService()
    loaderState.changeLoaderState({isInProgress: true})

    const response = fetch(endpoint, {
      method: "POST",
      headers: Object.fromEntries(headerResult.getValue()),
      credentials: "include",
      mode: "cors",
      body: serializeToJson(request),
    })
      .then(async (response) => ({
        filename: pdfFileName,
        blob: await response.blob(),
      }))
      .then((resObj) => {
        // It is necessary to create a new blob object with mime-type explicitly set for all browsers except Chrome, but it works for Chrome too.
        const newBlob = new Blob([resObj.blob], { type: "application/pdf" });
  
        // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
           (window.navigator as any).msSaveOrOpenBlob(newBlob);
        } else {
          // For other browsers: create a link pointing to the ObjectURL containing the blob.
          const objUrl = window.URL.createObjectURL(newBlob);
  
          const link = document.createElement("a");
          link.href = objUrl;
          // eslint-disable-next-line
          var temp: any = resObj;
          link.download = temp.filename;
          link.click();
  
          // For Firefox it is necessary to delay revoking the ObjectURL.
          setTimeout(() => {
            window.URL.revokeObjectURL(objUrl);
          }, 250);
        }
        loaderState.changeLoaderState({isInProgress: false})    
      })
      .catch((error) => {        
        loaderState.changeLoaderState({isInProgress: false})    
      });
  }
}
